<div class="page-wrapper" fxLayoutAlign="center center" fxLayout="column">
    <div class="content-wrapper">
        <!-- <app-desktop-category-menu [data]="categories" (searchQuery)="searchInput($event)" [showInput]="true"></app-desktop-category-menu> -->
        <div>
            <!-- <div class="category-name-container" fxLayout="row">
                <div fxLayoutAlign="center center" class="category-title">
                    <img class="category-icon" src="{{!!category?.icon ? category?.icon?.url : 'assets/desktop/top-games-icon.svg'}}" (load)="isCategoryImageLoaded = true" [fxShow]="isCategoryImageLoaded">
                    <h1>{{categoryName}}</h1>
                </div>
            </div> -->
            <app-common-page-title icon="{{category?.icon?.url}}">{{categoryName}}</app-common-page-title>
            <app-inner-loader *ngIf="isLoading"></app-inner-loader>
            <div class="content-wrap" *ngIf="!isLoading">
                <ng-container *ngIf="games">
                    <div class="game-card-wrapper" [ngClass]="{'rectangular': desktopSize==='rectangular'}" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
                        <ng-container *ngFor="let item of games">
                            <div class="game-card" *ngIf="isLoggedIn || (!item.hideGame && !isLoggedIn)">
                                <app-desktop-game-card (clickEvent)="openDialog($event)" [size]="desktopSize" [data]="item"></app-desktop-game-card>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
        <app-desktop-expansion-panel [data]="expansionPanel"></app-desktop-expansion-panel>
    </div>
</div>